import { getConfig } from './getConfig';
import cookie from './cookie';

// eslint-disable-next-line no-shadow
export const enum UnifiedPlatformEndpoints {
  kyc = 'kyc/v1/',
  kycAccount = 'kyc/v1/accounts',
  kycFeatureFlag = 'kyc/v1/am-i-unified',
  claims = 'safedeal/u/claims',
  safeDealOrder = `safedeal/u/order`,
  returns = 'returns/v1/returns',
  returnsDetails = 'returns/v2/return',
  returnsPaymentLink = 'returns/v1/return',
  loyaltyPointsOptInStatus = 'loyalty-points/v1/opt-in',
  loyaltyPointsPreviewPoints = 'loyalty-points/v1/preview-points',
  loyaltyPointsFlagHubVisible = 'loyalty-points/v1/flag/loyalty-hub-visible/users',
  loyaltyPointsWhitelistUser = 'loyalty-points/v1/whitelist',
}

export type UnifiedPlatformEndpointsResponses = {
  [UnifiedPlatformEndpoints.loyaltyPointsOptInStatus]: {
    data: {
      status: 'OPTED_IN' | 'NOT_OPTED_IN';
      optedInAt?: string;
      variant?: {
        id: string;
        pointsPerCurrency: number;
        pointsCap?: number;
      };
    };
  };
  [UnifiedPlatformEndpoints.loyaltyPointsPreviewPoints]: {
    data: {
      isMonthlyCapReached: boolean;
      pointsMonthlyCapAmount: number;
      pointsFromTransaction: number;
    };
  };
  [UnifiedPlatformEndpoints.loyaltyPointsFlagHubVisible]: 'VISIBLE' | 'NOT_VISIBLE';
  [UnifiedPlatformEndpoints.loyaltyPointsWhitelistUser]: 'WHITELISTED' | 'NOT_WHITELISTED';
};

export const getUnifiedPlatformBaseUrl = () => {
  const { environment, unifiedPlatformAPI } = getConfig();
  switch (environment) {
  case 'production':
    return unifiedPlatformAPI.production;
  case 'staging':
  case 'localhost':
    return unifiedPlatformAPI.staging;
  default:
    throw new Error('Environment must be set!');
  }
};

export const fetchUnifiedPlatformAPI = ({
  endpoint,
  method = 'GET',
  body = undefined,
  contentType = 'application/json',
}: {
  endpoint: string;
  method?: 'GET' | 'POST';
  body?: BodyInit;
  contentType?: string;
}) => {
  const token = cookie.get('access_token');

  if (token === null) {
    return Promise.reject(new Error('Fetch Unified Platform API - No access token available'));
  }

  const url = getUnifiedPlatformBaseUrl();

  return fetch(`${url}/${endpoint}`, {
    headers: {
      'Content-Type': contentType,
      authorization: `Bearer ${token}`,
    },
    method,
    body,
  });
};
